import { FC, ReactNode, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useSetAtom } from 'jotai';
import { filePreviewAtom } from 'atoms/file-preview/filePreview';
import { uploadedFilesStyles as styles } from '../../uploaded-files/styles/styles';

type FileWrapperProps = {
  url: string;
  mimeType: string;
  fileId?: string | number;
  children?: ReactNode;
};

export const FileWrapper: FC<FileWrapperProps> = ({ children, fileId, url, mimeType }) => {
  const setPreview = useSetAtom(filePreviewAtom);

  useEffect(() => {
    if (!fileId) return;
    setPreview((prev) => {
      if (!prev || prev.url !== url || prev.fileId === fileId) return prev;
      return { ...prev, fileId };
    });
  }, [fileId, url, setPreview]);

  return (
    <Grid
      onClick={() => setPreview({ url, mimeType, fileId })}
      sx={styles.wrapperContainer}
    >
      {children}
    </Grid>
  );
};
